import React, { useState, useContext } from "react";
import {
    UiAuthContainer,
    UiAuthFooterContainer
} from "../../_uiComponents/common/custom/header/UiTopNavElements";

import ResetPassword from "../auth/forms/ResetPassword";


export default function ResetPasswordWrapper(props) {
    return (
        <>
            <UiAuthContainer >
                <div className="sb-auth-top-wr">
                    <h2>Reset Password</h2>
                    <ResetPassword />
                    <UiAuthFooterContainer/>
                </div>
            </UiAuthContainer>


        </>
    );
}
